import styled from 'styled-components';

export const StyledPinRow = styled.div`
  width:  100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 43px 0 24px;
`;

export const StyledPinDot = styled.span<{ filled?: boolean }>`
  display: inline-block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1.5px solid #1A1A1A;
  background: ${props => props.filled ? '#1A1A1A' : 'transparent'};
`;

export const StyledRow = styled.div`
  width:  100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 43px 0 24px;
`;